import Dialog, { IDialogOptions } from "~/ui/dialog";
import { createDialogButton } from "~/ui/dialogbutton";
import { node } from "~/util/dom";
import { _ } from "~/i18n";

interface IActiveRequestCloseDialogOptions extends IDialogOptions {
	onUnknownPlace: (event: Event) => void;
	onRemindLater: (event: Event) => void;
	onRemindNever: (event: Event) => void;
	onCancel: (event: Event) => void;
}

export default class ActiveRequestCloseDialog {
	_unknownPlaceButton: HTMLButtonElement;

	_remindLaterButton: HTMLButtonElement;

	_remindNeverButton: HTMLButtonElement;

	_cancelButton: HTMLButtonElement;

	_onUnknownPlace: (event: Event) => void;

	_onRemindLater: (event: Event) => void;

	_onRemindNever: (event: Event) => void;

	_onCancel: (event: Event) => void;

	_dialog: Dialog;

	constructor({
		onUnknownPlace,
		onRemindLater,
		onRemindNever,
		onCancel,
		...args
	}: IActiveRequestCloseDialogOptions) {
		this._dialog = new Dialog({
			...args,
		});
		this._onUnknownPlace = onUnknownPlace;
		this._onRemindLater = onRemindLater;
		this._onRemindNever = onRemindNever;
		this._onCancel = onCancel;

		this._dialog.dom.container.classList.add("ar-CloseDialog");

		// nadpis
		this._dialog.dom.content.appendChild(node("h2", { innerHTML: _("activerequest.close.title") }));

		// tlacitka
		this._unknownPlaceButton = createDialogButton({ innerHTML: _("activerequest.close.unknownPlace") });
		this._unknownPlaceButton.setAttribute("data-log-ignore", "true");
		this._dialog.dom.content.appendChild(this._unknownPlaceButton);

		this._remindLaterButton = createDialogButton({ innerHTML: _("activerequest.close.remindLater") });
		this._remindLaterButton.setAttribute("data-log-ignore", "true");
		this._dialog.dom.content.appendChild(this._remindLaterButton);

		this._remindNeverButton = createDialogButton({ innerHTML: _("activerequest.close.remindNever") });
		this._remindNeverButton.setAttribute("data-log-ignore", "true");
		this._dialog.dom.content.appendChild(this._remindNeverButton);

		this._cancelButton = createDialogButton({ innerHTML: _("cancel") });
		this._cancelButton.setAttribute("data-log-ignore", "true");
		this._dialog.dom.content.appendChild(this._cancelButton);

		this._dialog.dom.content.addEventListener("click", this, false);
	}

	destroy() {
		this._dialog.dom.content.removeEventListener("click", this, false);
		this._dialog.destroy();
	}

	handleEvent(event: Event) {
		const target = event.target as HTMLElement;

		if (this._unknownPlaceButton.contains(target)) {
			this._onUnknownPlace(event);
		} else if (this._remindLaterButton.contains(target)) {
			this._onRemindLater(event);
		} else if (this._remindNeverButton.contains(target)) {
			this._onRemindNever(event);
		} else if (this._cancelButton.contains(target)) {
			this._onCancel(event);
		} else {
			this._dialog.handleEvent(event);
		}
	}

	close() {
		this._dialog.close();
	}

	open() {
		this._dialog.open();
	}
}
